/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React TS Base Styles
import colors from "assets/theme-dark/base/colors";

const { background, info } = colors;

// types
type Types = any;

const accordions: Types = {
  styleOverrides: {
    // Seção um degrau acima do modal, com o cabeçalho no azul de destaque do
    // sistema: na cor do modal ela sumia, e o azul acinzentado do template
    // destoava do resto.
    root: {
      backgroundColor: background.raised,
      border: "1px solid rgba(255, 255, 255, 0.08)",
      boxShadow: "none",

      "& > .MuiAccordionSummary-root": {
        backgroundColor: "rgba(26, 115, 232, 0.10)",
        borderLeft: `3px solid ${info.main}`,
      },

      "&.Mui-expanded > .MuiAccordionSummary-root": {
        borderBottom: "1px solid rgba(255, 255, 255, 0.08)",
      },
    },
  },
};

export default accordions;
